exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.height-100[data-v-28fe9c1a]{\n    height: 100px;\n}\n.message-right[data-v-28fe9c1a]{\n    float:right;\n}\n.ctext-wrap[data-v-28fe9c1a]{\n    padding:10px 10px;\n    background-color: #eff2f7;\n    margin:10px;\n    border-radius: 8px 8px 0px 8px;\n}\n.main-message[data-v-28fe9c1a]\n{\n    min-height: 100px;\n    max-height: 300px;\n    overflow: auto;\n}\n", ""]);

// exports
